/**
 * Order of the main feature categories in feature pickers; unknown categories go last.
 */
export const FEATURE_SECTION_ORDER = [
  'FEATURE_CATEGORY_COMFORT_CONVENIENCE',
  'FEATURE_CATEGORY_SECURITY_SAFETY_ASSISTANCE',
  'FEATURE_CATEGORY_TRANSMISSION_AND_SUSPENSION',
  'FEATURE_CATEGORY_ACCESSORIES_AND_EXTRA_FEATURES',
];
